export enum itemsHistorySections {
    purchaseList = 'purchase-list',
    reservation = 'reserved',
}
